

import Navbar from "@/components/Navbar";
import ModernHero from "@/components/marketing/ModernHero";
import PlatformShowcase from "@/components/marketing/PlatformShowcase";
import ModernFeatures from "@/components/marketing/ModernFeatures";
import ModernTestimonials from "@/components/marketing/ModernTestimonials";
import ModernCTA from "@/components/marketing/ModernCTA";
import Footer from "@/components/Footer";
const MarketingSite = () => {

  return (
    <div className="bg-background min-h-screen">
      <Navbar />
      <main>
        <ModernHero />
        <PlatformShowcase />
        <ModernFeatures />
        <ModernTestimonials />
        <ModernCTA />
      </main>
      <Footer />
    </div>
  );
};

export default MarketingSite;
